<template>
  <div class="aside-wrap">
    <div class="placeholder" :class="{'placeholder-active':isAsideStick}"></div>
    <div class="aside" :class="{'asideStick':isAsideStick}">
      <h5>任务列表</h5>
      <Input
        search
        icon="ios-search-outline"
        class="input-search-task"
        placeholder="搜索任务"
        @on-change="filterTask"
        v-model="value_searchTask"
      />
      <div class="taskList-wrap" ref="taskListWrap">
        <transition name="barScrollTop">
          <div ref="barTop" class="bar-scrollToTop" v-show="isShowBarTop"></div>
        </transition>
        <ul class="taskList" ref="taskList" id="taskList">
          <li
            :class="['taskList-item', item.jobId===currentTaskId?'active':'']"
            :title="item.jobName"
            v-for="item in taskList_search"
            :key="item.jobId"
            @click="handleSelectTask(item.jobId)"
          >{{ item.jobName }}</li>
        </ul>
        <transition name="barScrollEnd">
          <div ref="barEnd" class="bar-scrollToEnd" v-show="isShowBarEnd"></div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //是否是从搜索结果页面跳转过来的
      isFromSearch: false,
      //正在加载任务列表数据
      isLoadingTaskData: false,
      //当前任务id
      currentTaskId: "",
      //任务列表的完整数据
      taskList: [],
      //任务列表当前显示的数据
      taskList_search: [],
      //<搜索任务>输入框中的文本
      value_searchTask: "",
      //侧边栏是否吸顶
      isAsideStick: false,
      //任务列表搜索输入框防抖timer
      timer_taskList: null,
      //控制向上箭头的显示
      isShowBarTop: false,
      //控制向下箭头的显示
      isShowBarEnd: false,
      //ul期望高度
      height_ul: "",
      //获取任务列表内部li的高度和
      height_li: ""
    };
  },
  methods: {
    //获取任务列表数据,渲染任务列表
    getTaskData() {
      //先判断当前页是群组监测/媒体监测
      let pageName = this.$route.name;
      let url = "";
      if (this.$route.name === "groupSpec") {
        url = "./sentiment/groupMsgData/jobList";
      } else if (this.$route.name === "mediaSpec") {
        url = "./sentiment/longTxtData/jobList";
      }
      if (this.isLoadingTaskData) return;
      this.isLoadingTaskData = true;
      this.$ajax({
        method: "get",
        url
      })
        .then(res => {
          this.isLoadingTaskData = false;
          if (res.data.success) {
            //如果res.data不为空
            if (res.data.data) {
              this.taskList = [...res.data.data];
              this.taskList_search = [...res.data.data];
            }
            //如果任务列表不为空
            if (this.taskList_search.length !== 0) {
              if (this.isFromSearch) {
                //如果来自于搜索结果页,trigger click相关任务
                let isCurrentTaskIdInList = this.taskList_search.some(
                  item => this.currentTaskId == item.jobId
                );
                if (!isCurrentTaskIdInList) {
                  //如果用户手动修改了url上的jobId，导致currentTaskId不存在于taskList中，则currentTaskId就是任务列表中的第一个任务id
                  this.currentTaskId = this.taskList_search[0].jobId;
                }
                this.handleSelectTask(this.currentTaskId);
                //然后根据currentTaskId的位置滚动到相关位置
                let indexOfCurrentTaskId = this.taskList_search.findIndex(
                  item => item.jobId === this.currentTaskId
                );
                indexOfCurrentTaskId =
                  indexOfCurrentTaskId == -1 ? 0 : indexOfCurrentTaskId;
                this.$nextTick(() => {
                  this.$refs.taskList.scrollTo(0, indexOfCurrentTaskId * 47);
                });
              } else {
                //如果不是来自搜索结果页，trigger click第一个任务
                this.currentTaskId = this.taskList_search[0].jobId;
                this.handleSelectTask(this.currentTaskId);
              }

              this.$nextTick(() => {
                //列表渲染完成后，调用子组件的方法，计算ul和li的高度
                this.get_li_height();
                //列表渲染完成后，再绑定ul的scroll事件
                this.bindActions();
              });
            }
          } else {
            if (res.data.code === 401) {
              this.toLogin();
            } else {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.isLoadingTaskData = false;
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //任务列表中<搜索框>输入文本时过滤任务
    filterTask() {
      //防抖
      clearTimeout(this.timer_taskList);
      this.timer_taskList = setTimeout(() => {
        this.taskList_search = this.taskList.filter(item =>
          item.jobName.includes(this.value_searchTask)
        );
        this.$nextTick(() => {
          //这样会修改li的高度，因此每次搜索之后都要计算一下
          this.get_li_height();
        });
      }, 300);
    },
    //点击<任务列表>中的任务时，触发父组件中的按任务查询消息的事件
    handleSelectTask(jobId) {
      this.currentTaskId = jobId;
      this.$emit("handleSelectTask", jobId);
    },
    //给任务列表绑定滚动监听事件、给提示箭头绑定点击事件
    bindActions() {
      //给任务列表绑定滚动事件
      this.$refs.taskList.addEventListener("scroll", e => {
        if (e.target.scrollTop < 30) {
          //快要滚动到顶时，隐藏向上的箭头
          this.isShowBarTop = false;
        } else if (e.target.scrollTop >= 30) {
          //当向下滚动时，显示向上的箭头
          this.isShowBarTop = true;
        }
        if (e.target.scrollTop > this.height_li - this.height_ul - 30) {
          this.isShowBarEnd = false;
        } else if (e.target.scrollTop <= this.height_li - this.height_ul - 30) {
          this.isShowBarEnd = true;
        }
      });
      //给向上箭头绑定点击事件
      this.$refs.barTop.addEventListener(
        "click",
        e => {
          $("#taskList").animate({ scrollTop: 0 }, 300);
        },
        false
      );
      //给向下箭头绑定点击事件
      this.$refs.barEnd.addEventListener(
        "click",
        e => {
          $("#taskList").animate(
            { scrollTop: this.height_li - this.height_ul },
            300
          );
        },
        false
      );
    },
    //计算任务列表li的高度
    get_li_height() {
      this.height_li = this.taskList_search.length * 47;
      //如果li-ul > 30，说明有一个任务被覆盖了，因此展现向下箭头
      if (this.height_li - this.height_ul > 30) {
        this.isShowBarEnd = true;
      } else {
        this.isShowBarEnd = false;
      }
    },
    //为侧边栏添加吸顶功能
    asideStickToTop() {
      this.$nextTick(() => {
        window.addEventListener("scroll", this.addAsideScrollEvent, false);
      });
    },
    //给window绑定滚动事件
    addAsideScrollEvent(e) {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 90) {
        //令aside吸顶
        this.isAsideStick = true;
      } else {
        this.isAsideStick = false;
      }
    },
    //给window解除滚动事件
    removeScrollEvent() {
      window.removeEventListener("scroll", this.addAsideScrollEvent);
    }
  },
  created() {
    let jobId = this.$route.query.jobId;
    if (jobId) {
      this.isFromSearch = true;
      this.currentTaskId = jobId;
    } else {
      this.isFromSearch = false;
    }
  },
  mounted() {
    //获取任务列表数据
    this.getTaskData();
    //为侧边栏绑定吸顶事件
    this.asideStickToTop();
    this.$nextTick(() => {
      //计算aside期望高度
      let asideHeight = document.documentElement.clientHeight - 60;
      //计算任务列表期望高度
      let taskListHeight = (this.height_ul =
        asideHeight - 30 - 15 - 32 - 20 - 70);
      this.$refs.taskList.style.height = taskListHeight + "px";
    });
  },
  destroyed() {
    this.removeScrollEvent();
  }
};
</script>

<style lang="less" scoped>
.aside-wrap {
  .barScrollTop-enter,
  .barScrollTop-leave-to,
  .barScrollEnd-enter,
  .barScrollEnd-leave-to {
    opacity: 0;
  }

  .barScrollTop-enter-active,
  .barScrollTop-leave-active,
  .barScrollEnd-enter-active,
  .barScrollEnd-leave-active {
    transition: all 0.4s ease-in;
  }

  .barScrollTop-enter-to,
  .barScrollTop-leave,
  .barScrollEnd-enter-to,
  .barScrollEnd-leave {
    opacity: 1;
  }

  .placeholder {
    width: 225.66px;
    height: 1px;
    opacity: 1;
    position: fixed;
  }
  .placeholder-active {
    position: static;
    width: 225.66px;
    height: 1px;
  }
  .aside {
    background-color: #fff;
    padding: 35px 0;
    overflow: hidden;
    h5 {
      font-family: PingFangSC-Medium;
      font-size: 20px;
      color: #333333;
      letter-spacing: -0.41px;
      text-align: left;
      padding-left: 30px;
    }
    .input-search-task {
      margin-left: -5px;
      width: 160px;
      margin-top: 15px;
    }
    .taskList-wrap {
      overflow: hidden;
      position: relative;
      .bar-scrollToTop {
        display: flex;
        cursor: pointer;
        &:hover {
          opacity: 0.7;
        }
        &::before {
          content: "";
          display: inline-block;
          margin: auto;
          transform: translateY(-3px);
          height: 0;
          width: 0;
          border-width: 7px;
          border-style: solid;
          border-color: transparent transparent #fff transparent;
        }
        position: absolute;
        z-index: 9999;
        background-color: rgba(0, 0, 0, 0.3);
        height: 20px;
        width: 100%;
        top: 20px;
      }
      .taskList {
        margin-top: 20px;
        overflow-y: auto;
        width: 100%;
        .taskList-item {
          height: 47px;
          line-height: 47px;
          font-family: PingFangSC-Regular;
          font-size: 18px;
          color: #333333;
          letter-spacing: -0.37px;
          text-align: left;
          padding-left: 30px;
          cursor: pointer;
          transition: all 0.2s ease-in-out;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
        }
        .taskList-item:hover {
          background-color: #f5f5f5;
        }
        .active {
          background-color: rgb(214, 217, 247) !important;
          color: #415af6 !important;
        }
      }
      .bar-scrollToEnd {
        display: flex;
        cursor: pointer;
        &:hover {
          opacity: 0.7;
        }
        &::before {
          content: "";
          display: inline-block;
          margin: auto;
          transform: translateY(3px);
          height: 0;
          width: 0;
          border-width: 7px;
          border-style: solid;
          border-color: #fff transparent transparent transparent;
        }
        position: absolute;
        z-index: 99;
        background-color: rgba(0, 0, 0, 0.3);
        height: 20px;
        width: 100%;
        bottom: 0;
      }
    }
  }
  .asideStick {
    position: fixed;
    top: 0px;
    width: 225.66px;
    overflow-y: auto;
    z-index: 99;
  }
}
</style>
